/**
 * Created by Bart Decorte
 * Date: 2019-07-11
 * Time: 15:42
 */
import TablesShow from './TablesShow';
import Request from '../../utils/Request';
import RowDrag from '../../utils/RowDrag';
import { endpoints } from '../../utils/api';
import { modifierState } from '../../helpers/os';

class TablesShowList extends TablesShow {
  constructor() {
    const $form = $('.js-entry-form');
    super({ $root: $form });
  }

  bindListeners() {
    super.bindListeners();
    const $body = $('body');
    $('.entries .tr').on('click', (ev) => this.lRowClick(ev));
    $('.js-in-table-editable *').on('input change', (ev) =>
      this.lInTableEditableInputChanged(ev)
    );
    $body.on('dragstart', '.entries .tr', (ev) => {
      return this.lRowDragStart(ev);
    });
  }

  lRowClick(ev) {
    let cancel = ['input', 'select', 'textarea', 'a', 'label', '.select2'];
    if (
      $(ev.target).is(cancel.join(', ')) ||
      $(ev.target).parents(cancel.join(', ')).length
    ) {
      return true;
    }

    let $elt = $(ev.target).is('.tr')
      ? $(ev.target)
      : $(ev.target)
          .parents('.tr')
          .first();
    const location = $elt
      .find('.btn-edit')
      .first()
      .attr('href');

    if (modifierState(ev)) {
      window.open(location, '_blank');
      return false;
    }

    window.location = location;
    return false;
  }

  lInTableEditableInputChanged(ev) {
    const $target = $(ev.target);
    const entryId = $target
      .parents('[data-entry-id]')
      .first()
      .data('entry-id');
    const $column = $target.parents('[data-column-id]').first();
    const columnId = parseInt($column.data('column-id'));
    let value = $target.val();

    if ($target.is('input[type="checkbox"]')) {
      value = $target.is(':checked') ? 1 : 0;
    }

    if ($target.is('select[multiple]')) {
      value = value.join(',');
    }

    this.setEditableCellState($column);
    this.cancelScheduledColumnUpdate(entryId, columnId);

    if (ev.type == 'change') {
      this.updateColumn(entryId, columnId, value);
    } else {
      this.scheduleColumnUpdate(
        entryId,
        columnId,
        value,
        this.columnUpdateDelay
      );
    }
  }

  lRowDragStart(ev) {
    let $elt = $(ev.target).is('.tr')
      ? $(ev.target)
      : $(ev.target)
          .parents('.tr')
          .first();

    new RowDrag({
      $row: $elt,
      ev: ev,
      callback: (from, to, changes) => {
        const adjusted = this.adjustForDescendingSort(from, to);
        this.updateSort(adjusted.from, adjusted.to);
      },
    });
  }

  cancelScheduledColumnUpdate(entryId, columnId) {
    if (
      this.timeouts.hasOwnProperty(entryId) &&
      this.timeouts[entryId].hasOwnProperty(columnId)
    ) {
      clearTimeout(this.timeouts[entryId][columnId]);
      delete this.timeouts[entryId][columnId];

      if (Object.keys(this.timeouts[entryId]).length == 0)
        delete this.timeouts[entryId];
    }

    return this;
  }

  scheduleColumnUpdate(entryId, columnId, value, delay) {
    if (!this.timeouts.hasOwnProperty(entryId)) this.timeouts[entryId] = {};

    this.timeouts[entryId][columnId] = setTimeout(
      () => this.updateColumn(entryId, columnId, value),
      delay
    );
    return this;
  }

  updateColumn(entryId, columnId, value) {
    const $row = $('[data-entry-id="' + entryId + '"]');
    const $cell = $row.find('[data-column-id="' + columnId + '"]');
    this.setEditableCellState($cell, 'pending');
    this.propagateColumnValue(entryId, columnId, value)
      .then((x) => {
        this.setEditableCellState($cell, 'success');
      })
      .catch((x) => {
        this.setEditableCellState($cell, 'fail');
      });
  }

  setEditableCellState($tdElement, state) {
    // state: pending, success, fail, <undefined>
    const tdElement = $tdElement.get(0);
    const states = tdElement.querySelectorAll('.js-state');

    states.forEach((state) => {
      if (!state.classList.contains('d-none')) {
        state.classList.add('d-none');
      }
    });

    if (typeof state !== typeof undefined) {
      tdElement.querySelector(`.js-state--${state}`).classList.remove('d-none');
    }

    return this;
  }

  propagateColumnValue(entryId, columnId, columnValue) {
    const data = {
      columns: {
        existing: {
          [entryId]: { [columnId]: { value: columnValue } },
        },
      },
    };
    const request = new Request(
      this.updateColumnEndpoint(entryId),
      'PATCH',
      data
    );
    return request.execute();
  }

  updateColumnEndpoint(entryId) {
    let segments = endpoints.appendTraceSegments([
      'websites',
      esign.info.websiteId,
      'tables',
    ]);
    segments.push(entryId);
    return segments.join('/');
  }

  entryCount() {
    return $('.entries .tr').length;
  }

  isDescendingSort() {
    return $('.entries').is('[data-sort-direction="DESC"]');
  }
}

export default TablesShowList;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Tables/TablesShowList.js